/**
 * Роли приложения
 */
export enum Role {
  GUEST = 1,
  OPR = 2,
  DATA_ADM = 3,
  USER_ADM = 4,
  MIGRANT = 5,
  LECTOR = 6,
}
